export const downloadFile = (encodedUri, fileName, extension) => {
  const link = document.createElement('a');
  link.setAttribute(
    'href',
    'data:application/pdf;charset=utf-8;base64,' + encodedUri
  );
  let currentTimestamp = new Date().toISOString().substring(0,19).replace(/[T:.-]+/g, "");
  link.setAttribute('download', `${fileName}_${currentTimestamp}.${extension}`);
  document.body.appendChild(link); // Required for FF
  return Promise.resolve(link.click());
};
